<template>
  <div>
    <div
      class="flex items-center bg-red-500 text-white px-4 py-3 mb-8"
      role="alert"
    >
      <i class="fas fa-exclamation-triangle"></i>
      <div class="ml-4">
        <span v-for="(error, index) in errors" :key="key(index)">
          {{ error }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["errors"],
  methods: {
    key(index) {
      return `error_message_${index}_${Math.random}`;
    },
  },
};
</script>
